import axios from "axios";
import Alert from "components/misc/Alert";
import NoDataFound from "components/misc/NoDataFound";
import TableCol from "components/misc/TableCol";
import TableHeader from "components/misc/TableHeader";
import PriceValue from "components/partials/PriceValue";
import Api from "helpers/Api";
import moment from "moment";
import { useAppContext } from "providers/App";
import { useAuthDataContext } from "providers/Auth";
import { useEffect, useRef, useState } from "react";
import { Button, Col, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Refs from "Refs";

function Invoices(props) {

    const app = useAppContext();
    const auth = useAuthDataContext();
    const navigate = useNavigate();

    const tableRef = useRef(null);

    const { createMarkup, highlight } = props;

    const [state, setState] = useState({
        loading: true,
        refresh: false,
        setFilter: false,
        data: [

        ],
        filter: {

        },
        request: null,
    });

    useEffect(() => {
        if (props.refresh) {
            loadData();
        }
    }, [state.refresh, props.refresh, props.keyword]);

    useEffect(() => {
        if (state.loading) {
            props.onLoadStart();
        } else {
            props.onLoadEnd();
        }
    }, [state.loading]);

    useEffect(() => {
        props.onResult(state.data.length);
    }, [state.data]);

    const loadData = () => {
        if (state.request) {
            state.request.cancel();
        }

        let request = axios.CancelToken.source();

        setState(prev => ({
            ...prev,
            request: request,
            loading: true,
        }));

        let url = 'search/invoices';

        Api.get(url, {
            params: {
                keyword: props.keyword
            },
            cancelToken: request.token
        }).then(res => {
            setState(prev => ({
                ...prev,
                data: res.data.items,
                loading: false,
                sorting: false,
                filter: {
                    ...prev.filter,
                    ...res.data.filter,
                }
            }));
        });
    }

    const show = id => {
        let modal = Refs.getInstance().getRef('invoice');

        modal.open(id);
    }

    const all = () => {
        navigate('/invoices?search=' + props.keyword);
    }

    if (state.data.length === 0) {
        return null;
    }

    return (
        <Col xl={6} lg={6}>
            <div className="card">
                <div className="d-flex card-header justify-content-between align-items-start">
                    <h4 className="header-title">Фактури</h4>

                    <Button
                        variant="dark"
                        size="sm"
                        onClick={all}
                    >
                        Всички фактури
                    </Button>
                </div>
                <div className="card-body with-table pt-0">
                    {state.data.length === 0
                        ?
                        <NoDataFound />
                        :
                        <Table className="" responsive striped hover ref={tableRef}>
                            <TableHeader
                                tableRef={tableRef}
                            >
                                <TableCol>ID</TableCol>
                                <TableCol className="text-center">Тип</TableCol>
                                <TableCol>Номер</TableCol>
                                <TableCol>Дата</TableCol>
                                <TableCol>Клиент</TableCol>
                                <TableCol className="text-right">Сума</TableCol>
                            </TableHeader>
                            <tbody>
                                {state.data.map(c =>
                                    <tr
                                        key={'c-' + c.id}
                                        className={c.deleted ? 'deleted' : ''}
                                    >
                                        <td>
                                            <span className="link" onClick={e => show(c.id)} dangerouslySetInnerHTML={createMarkup(highlight(c.id))} />
                                        </td>
                                        <td className="text-center" style={{ backgroundColor: c.type?.background, color: c.type?.color }}>
                                            {c.type?.name}
                                        </td>
                                        <td>
                                            <span dangerouslySetInnerHTML={createMarkup(highlight(c.no))} />
                                        </td>
                                        <td>
                                            <span>
                                                {c.date ? moment(c.date).format('DD.MM.YYYY') : ''}
                                            </span>
                                        </td>
                                        <td>
                                            <span dangerouslySetInnerHTML={createMarkup(highlight(c.client?.name))} />
                                        </td>
                                        <td className="text-right">
                                            <PriceValue>{c.gross_price}</PriceValue>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    }
                </div>
            </div>
        </Col>
    )
}

export default Invoices;